module.exports = __webpack_public_path__ + "static/media/bio_ombre.31cd9984.png";